import { ButtonThemeType, IStyleConfig, Link, mergeStyles, VisualSize } from '@cian/components';
import * as React from 'react';
const styles = require('./pik_link.css');

export interface ILinkProps {
  pikStyles?: IStyleConfig;
  theme?: ButtonThemeType;
  pikTheme?: 'orange';
  size?: VisualSize;
  href: string;
  target?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

export class PikLink extends React.PureComponent<ILinkProps, object> {
  public render() {
    const { pikTheme } = this.props;
    const linkStyles = mergeStyles(styles['link'], pikTheme && styles[pikTheme], this.props.pikStyles);

    return (
      <Link {...this.props} linkStyle={[linkStyles.className, linkStyles.style]} onClick={this.props.onClick}>
        {this.props.children}
      </Link>
    );
  }
}
